import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import NoticeCard from "@root/components/Notice/NoticeCard";
import useMediaQ from "@root/hooks/useMediaQ";

interface UnauthenticatedNoticeListProps {
    notices?: any[];
    loading: boolean;
    /** When true, list will expand to full container height on desktop */
    fullHeight?: boolean;
}

export const UnauthenticatedNoticeList = ({
    notices,
    loading,
    fullHeight = false,
}: UnauthenticatedNoticeListProps) => {
    const { sm } = useMediaQ();
    const isMobile = !sm;

    if (loading) {
        return (
            <Flex justify="center" align="center" minH="200px">
                <Spinner size="lg" />
            </Flex>
        );
    }

    if (!notices || notices.length === 0) {
        return (
            <Flex justify="center" align="center" width="100%" minH="80px">
                <Text fontSize="14px" color="#5C6670" textAlign="center">
                    No notices available.
                </Text>
            </Flex>
        );
    }

    return (
        <Box
            width="100%"
            overflowY="auto"
            overflowX="hidden"
            maxH={
                fullHeight
                    ? "100%"
                    : isMobile
                        ? "330px"
                        : "390px"
            }
            css={{
                "&::-webkit-scrollbar": { width: "4px" },
                "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "2px",
                },
                "&::-webkit-scrollbar-thumb": {
                    background: "#c1c1c1",
                    borderRadius: "2px",
                },
                "&::-webkit-scrollbar-thumb:hover": { background: "#a8a8a8" },
            }}
        >
            <Flex flexDirection="column" gap="8px" pr="4px">
                {notices.map((notice: any, idx: number) => (
                    <NoticeCard
                        key={idx}
                        notice={notice}
                        showThumbnail={false}
                        compact
                    />
                ))}
            </Flex>
        </Box>
    );
};


